define('home/models/activities/ChannelPostActivity',[
    'home/models/Activity',
    'home/activityExpander',
], function (
    Activity,
    activityExpander
) {
    'use strict';

    /**
     * User writes and submits a comment to a channel
     *
     * Relations {
     *     actor: {
     *         type: 'user',
     *         description: 'The user that posted the comment'
     *     },
     *     object: {
     *         type: 'post',
     *         description: 'The comment that was posted'
     *     }
     * }
     */
    var ChannelPostActivity = Activity.extend({
        defaults: {
            verb: 'channel-post',
        },

        initialize: function (attributes) {
            this.actor = attributes.actor;
            this.object = attributes.object;
            this.thread = this.object.thread;
        },

        parseRelatedModels: function (attributes, objects) {
            attributes.actor = activityExpander.buildUser(objects, attributes.actor);
            attributes.object = activityExpander.buildPost(objects, attributes.object);

            return attributes;
        },
    });

    return ChannelPostActivity;
});


